<template>
  <div class="container-fluid">
    <div class="row mb-3">
      <div class="col-sm-12 text-center">
        <h1 class="title">
          My offers
        </h1>
        <!-- <h4>Insurance company</h4>
        <pre>{{ offers }}</pre> -->
      <button type="button" class="btn btn-primary" @click="pay">Pay</button>
      </div>
    </div>
    <div class="row">
      <template v-if="offers.length">
        <div v-for="(item, index) in offers" :key="index" class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="cursor-pointer" style="position:absolute; right: 10px; z-index:2">
                  <i class="mdi mdi-delete text-danger" @click="deleteOffer(item)"></i>
                  <i class="mdi mdi-lead-pencil text-warning" @click="displayOffer(item, index)"></i>
                </div>
                <div class="col-sm-12 d-flex">
                  <div class="product-icon-rounded d-flex justify-content-center align-items-center flex-grow-0 flex-shrink-0 cursor-pointer" style="height: 80px; width:80px;">
                    <svg class="svg-icon svg-icon--product" style="width:3em; height:3em;">
                      <use :xlink:href="require(`@/assets/img/${item.CS_DATA.PRODUCT}.svg`) + `#${item.CS_DATA.PRODUCT}`"></use>
                    </svg>
                  </div>
                  <div class="flex-grow-1 flex-shrink-1 ml-3 align-self-center">
                    <div class="row">
                      <div class="col-lg-3">
                        <h3>{{ item.CS_DATA.MANUFACTURER_DESC }} {{ item.CS_DATA.MODEL_DESC }}</h3>
                        <h4>{{ item.CS_DATA.LICENSE_PLATE }}</h4>
                      </div>
                      <div class="col-lg-9">
                        <h2>{{ item.CS_DATA.OFFER_NO }}</h2>
                        <h2>{{ item.CS_DATA.CS_PROPOSAL.TITLE }} - {{ $u.formatMoney(item.CS_DATA.CS_PROPOSAL.PREMIUM) }}</h2>
                        <div v-popper="{ placement: 'bottom-end' }">
                          <a href="javascript:;" class="" popper-trigger>
                            <span>
                              {{ item.CS_DATA.CS_PROPOSAL.CT_COVERS.length + item.CS_DATA.CT_COVERS.length }} Covers
                              <!-- <i class="mdi mdi-chevron-down"></i> -->
                            </span>
                          </a>
                          <div class="dropdown-menu dropdown-menu-right p-3" popper>
                            <div :class="['row', item.CS_DATA.CT_COVERS.length && 'pb-2 mb-2 border-bottom']">
                              <div class="col">
                                <ul class="pl-0 mb-0 list-unstyled">
                                  <template v-for="coverItem in item.CS_DATA.CS_PROPOSAL.CT_COVERS">
                                    <li :key="coverItem.TITLE"><i class="mdi mdi-check-bold text-success"></i> {{ coverItem.TITLE }}</li>
                                  </template>
                                </ul>
                              </div>
                            </div>
                            <div v-if="item.CS_DATA.CT_COVERS.length" class="row">
                              <div class="col">
                                <h6 class="mb-1">Optional Covers</h6>
                                <ul class="pl-0 mb-0 list-unstyled">
                                  <template v-for="coverItem in item.CS_DATA.CT_COVERS">
                                    <li :key="coverItem.TITLE"><i class="mdi mdi-check-bold text-success"></i> {{ coverItem.TITLE }}</li>
                                  </template>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <pre>{{ item.CS_DATA }}</pre> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="col-sm-12 text-center">
          <h2>Currently there is no offers</h2>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
// import qs from 'qs';

export default {
  name: 'MyOffers',
  computed: {
    ...mapState({
      offers: (state) => state.offer.offers
    })
  },
  async created() {
    await this.loadOffers();
  },
  methods: {
    ...mapActions('offer', ['getOffersAction', 'deleteOfferAction']),
    displayOffer(item) {
      if (item.CS_DATA.PRODUCT === 'MOTOR') {
        this.$router.push({ name: 'MotorDisplay', params: { id: item.CS_DATA.OFFER_NO } });
      }
    },
    async loadOffers() {
      await this.getOffersAction();
    },
    async deleteOffer(offer) {
      await this.deleteOfferAction(offer.CS_DATA.OFFER_NO);
    },
    async pay() {
      // const response = await axios.post('https://tjccpg.jccsecure.com/EcomPayment/RedirectAuthLink', qs.stringify({
      //   Version: '1.0.0',
      //   MerID: '0011223344',
      //   AcqID: '402971',
      //   MerRespURL: 'https://localhost:8080/offers',
      //   PurchaseAmt: '0000000020.50',
      //   PurchaseCurrency: 978,
      //   PurchaseCurrencyExponent: 2,
      //   OrderID: 'TestOrder12345',
      //   CaptureFlag: 'A',
      //   Signature: 'sU3MeEKlPx7HpiHnfBBt++goN3k=',
      //   SignatureMethod: 'SHA1'
      // },
      // {
      //   headers: {
      //     'Access-Control-Allow-Origin': '*',
      //   }
      // }));
      const response = await axios.post('https://tjccpg.jccsecure.com/EcomPayment/RedirectAuthLink', {});
      console.log(response);
    }
  },
};
</script>
